import api from './api';

// Team management — configures who has VMS access and their role
// (Admin, Operator, Packer, RTO). Backed by the QuirkyQode org-users API via
// the VMS backend's SSO-aware /api/auth/team endpoints. Client-admin only.
const teamService = {
    // List all org users with their VMS role annotated (vms_role)
    getTeam: async () => {
        const response = await api.get('/api/auth/team');
        return response.data;
    },

    // Create a new team member with a QuirkyQode login + assigned VMS role
    createMember: async ({ name, email, password, role, is_active = true }) => {
        const response = await api.post('/api/auth/team', { name, email, password, role, is_active });
        return response.data;
    },

    // Update a team member's name / password / role / active status
    updateMember: async (userId, updates) => {
        const response = await api.put(`/api/auth/team/${userId}`, updates);
        return response.data;
    },

    // Remove a team member's access entirely
    deleteMember: async (userId) => {
        const response = await api.delete(`/api/auth/team/${userId}`);
        return response.data;
    }
};

export default teamService;
